<template>
  <main class="modal modal-sm active" v-if="localActive" id="modal-id">
    <a @click="close()" class="modal-overlay" aria-label="Close"></a>
    <div class="modal-container">
      <div class="modal-header">
        <a @click="close()" class="btn btn-clear float-right" aria-label="Close"></a>
        <div class="modal-title h5">Acesso ao sistema</div>
      </div>
      <div class="modal-body">
        <drLogin @success="response($event)" />
      </div>
    </div>
  </main>
</template>

<script>
import drLogin from '@/components/form/login'
export default {
  props: ['active'],
  components: {
    drLogin
  },
  data () {
    return {
      localActive: this.active
    }
  },
  watch: {
    'active' (next, prev) {
      this.localActive = next
    }
  },
  methods: {
    close () {
      this.localActive = false
      this.$emit('cancel', true)
    },
    response (ev) {
      !ev ? this.close() : this.$router.push(`/${ev}/login`)
    }
  }
}
</script>
